import { Logo } from 'es/app/components/logo';
import cn from 'classnames';
import styles from './Throbber.module.css';
import { useTheme } from 'es/app/theme';
import { LinearProgress } from 'es/app/components/progress-indicators/linear-progress';
import { BootstrapStyles } from 'es/app/visuals/styles/BootstrapStyles';

interface IProps {
    text?: string | null;
    opacity?: number;
    visible?: boolean;
}

const Throbber = (props: IProps) => {
    const { themeName } = useTheme();
    if (!props.visible) return null;

    return (
        <div
            className={cn(styles.throbber, {
                [styles.throbberLight ?? '']: themeName === 'light',
                [styles.throbberDark ?? '']: themeName === 'dark',
            })}
        >
            <div className={styles.throbberBackground} />

            <div className={cn(BootstrapStyles['p-3'], styles.throbberContentContainer)}>
                <Logo className={styles.throbberLogo} />

                <div className={BootstrapStyles['ps-3']}>{props.text ?? 'Loading'}</div>
                <LinearProgress className={styles.throbberProgress} />
            </div>
        </div>
    );
};

export default Throbber;
